import React from 'react';
import ChevronDownIcon from "./ChevronDownIcon.mjs";

const ChevronUpIcon = class extends React.Component {
	render() { return <ChevronDownIcon style={{rotate: "180deg", ...(this.props.style||{})}} />; }
}

export default ChevronUpIcon;
